import React from "react";
import Lottie from "react-lottie";
import * as loadingData from "./quad-cube.json";

export default function Loading({ size = 200 }) {
  let loading = null;
  loading = loadingData.default;
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Lottie
        style={{ padding: 0 }}
        width={size}
        height={size}
        options={defaultOptions}
      />
    </div>
  );
}
